
import {
  defineComponent,
  ref,
  computed,
  useContext,
  useFetch,
  useMeta,
} from '@nuxtjs/composition-api';
import PageBlocks from '~/components/PageBlocks.vue';

export default defineComponent({
  components: {
    PageBlocks,
  },

  setup() {
    const {
      route,
      error,
      ssrContext,
      $api: { productsService },
      i18n,
    } = useContext();
    const page = ref();

    const fetchProduct = async () => {
      try {
        const { data } = await productsService.getProductBySlug(
          route.value.params.slug,
          { lang: i18n.locale },
        );
        page.value = data;
      } catch (e) {
        if (ssrContext) ssrContext.res.statusCode = 404;
        else error({ statusCode: 404 });
      }
    };

    useFetch(async () => {
      await fetchProduct();
    });

    const breadcrumbs = computed(() => [
      {
        text: page.value?.category_branch[0].name,
        link: `/catalog/${page.value?.category_branch[0].slug}`,
      },
      {
        text: page.value?.name,
      },
    ]);

    useMeta(() => ({
      title: page.value?.seo.page_title,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: page.value?.seo.description,
        },
        {
          property: 'og:title',
          content: page.value?.seo.og_title,
        },
        {
          property: 'og:description',
          content: page.value?.seo.description,
        },
      ],
    }));

    return {
      page,
      breadcrumbs,
    };
  },
  head: {},
});
